/**
 * @file
 */

export default {
    setFilterQuery(state, query) {
        state.filterQuery = query;
    },
    clearFilterQuery(state) {
        state.filterQuery = {};
    },
    setInitProcessState(state, val) {
        state.initProcessState = val;
    },
    // 设置只查未回复的帖子的默认选中状态
    setInitReply(state, val) {
        state.initReply = val;
    },
    setInitSelectProcess(state, val) {
        state.initSelectProcess = val;
    },
    setInitFollowInfo(state, val) {
        state.initFollowInfo = val;
    },
    setInitAuthorInfo(state, val) {
        state.initAuthorInfo = val;
    },
    setInitIssueFollowInfo(state, val) {
        state.initIssueFollowInfo = val;
    },
    setSelectedTime(state, time) {
        state.initSelectedTime = time;
    }
};
